import {createContext} from 'react';

const UserBasicInfoQRContext = createContext("Loading...");
export default UserBasicInfoQRContext;